{
  "list": {
    "title": "سجل الرسائل",
    "searchPlaceholder": "البحث برقم الهاتف",
    "filters": {
      "system": "النظام",
      "status": "الحالة",
      "fromDate": "من تاريخ",
      "toDate": "إلى تاريخ"
    },
    "columns": {
      "date": "التاريخ",
      "system": "النظام",
      "template": "القالب",
      "language": "اللغة",
      "phone": "الهاتف",
      "status": "الحالة",
      "attempts": "المحاولات"
    }
  },
  "status": {
    "queued": "بانتظار الإرسال",
    "sending": "قيد الإرسال",
    "sent": "تم الإرسال",
    "delivered": "تم التسليم",
    "read": "تمت القراءة",
    "failed": "فشل الإرسال"
  },
  "language": {
    "ar": "العربية",
    "en": "الإنجليزية"
  },
  "details": {
    "title": "تفاصيل الرسالة",
    "basicInfo": "المعلومات الأساسية",
    "system": "النظام",
    "templateKey": "مفتاح القالب",
    "templateName": "اسم القالب في Meta",
    "language": "اللغة",
    "idempotencyKey": "مفتاح عدم التكرار",
    "providerMessageId": "معرف الرسالة في Meta",
    "headerType": "رأس الرسالة",
    "headerNone": "بدون",
    "headerImage": "صورة ({{format}}، {{size}})",
    "headerImageSize": "{{value}} كيلوبايت",
    "variables": "المتغيرات",
    "variableName": "الاسم",
    "variableValue": "القيمة",
    "messageText": "نص الرسالة",
    "noMessageText": "لا يوجد نص محفوظ لهذا القالب.",
    "statusSteps": "الحالة",
    "steps": {
      "created": "الإنشاء",
      "sent": "الإرسال",
      "delivered": "التسليم",
      "read": "القراءة",
      "failed": "الفشل"
    },
    "attempts": "المحاولات",
    "nextAttemptAt": "المحاولة القادمة",
    "failureReason": "سبب الفشل",
    "retry": "إعادة الإرسال",
    "retryConfirmTitle": "إعادة إرسال هذه الرسالة؟",
    "retryConfirmDescription": "سيتم إعادة إرسال رسالة \"{{template}}\" إلى {{phone}}.",
    "retrySuccess": "تمت إعادة إرسال الرسالة بنجاح",
    "notFound": "تعذر العثور على هذه الرسالة.",
    "failureGeneric": "تعذر إرسال الرسالة. حاول مرة أخرى في وقت لاحق.",
    "failureCodes": {
      "1": "الخدمة غير متاحة في الوقت الحالي لدى مزود واتساب",
      "2": "الخدمة غير متاحة في الوقت الحالي لدى مزود واتساب",
      "4": "تم تجاوز الحد المسموح من الطلبات، حاول في وقت لاحق",
      "100": "بيانات الرسالة غير صحيحة",
      "130429": "تم تجاوز الحد المسموح من الرسائل، حاول في وقت لاحق",
      "131000": "تعذر على مزود واتساب تنفيذ الطلب، حاول مرة أخرى",
      "131026": "تعذر تسليم الرسالة، الرقم غير مسجل في واتساب أو لا يقبل الرسائل",
      "131030": "رقم المستلم غير مسموح له باستلام الرسائل",
      "131042": "مشكلة في الدفع لدى حساب واتساب للأعمال",
      "131047": "انتهت مهلة المحادثة، يلزم إرسال قالب جديد",
      "131048": "تم تقييد الإرسال بسبب كثرة الرسائل المرفوضة",
      "131049": "لم يتم تسليم الرسالة للحفاظ على جودة التفاعل مع المستلم",
      "131053": "فشل رفع صورة الرسالة، تحقق من الصورة",
      "131056": "تم تجاوز الحد المسموح من الرسائل لهذا المستلم، حاول في وقت لاحق",
      "132000": "عدد متغيرات القالب لا يطابق القالب المعتمد",
      "132001": "القالب غير موجود أو غير معتمد بهذه اللغة",
      "132005": "نص القالب بعد الترجمة طويل للغاية",
      "132012": "قيم متغيرات القالب غير صحيحة",
      "190": "انتهت صلاحية ربط حساب واتساب، يلزم تجديده",
      "PROVIDER_UNAVAILABLE": "خدمة واتساب غير متاحة حاليا، اطلب رمزا جديدا",
      "RECIPIENT_NOT_ON_WHATSAPP": "الرقم غير مسجل في واتساب",
      "TEMPLATE_NOT_APPROVED": "قالب رمز التحقق غير معتمد بعد في Meta",
      "PROVIDER_REJECTED": "رفض مزود واتساب الرسالة، اطلب رمزا جديدا"
    },
    "codeHidden": "الرمز مخفي",
    "codeNotResent": "لا يمكن إعادة إرسال رسالة رمز التحقق، اطلب رمزا جديدا."
  }
}
